import { useTranslation } from "react-i18next";
import { WindowTypeAndPropsDefinition } from "../../../windowManagerSlice";
import css from "./ShortcutWindow.module.css";

export interface ShortcutWindowProps {}

export type ShorcutWindowTypeAndProps = WindowTypeAndPropsDefinition<
	"shortcut",
	ShortcutWindowProps
>;

export function ShortcutWindow(props: ShortcutWindowProps & { id: string }) {
	const { t } = useTranslation();
	return (
		<div className={css.content}>
			<ul>
				<li>
					<strong>Ctrl + C: </strong>
					{t("copy")}
				</li>
				<li>
					<strong>Ctrl + V: </strong>
					{t("paste")}
				</li>
				<li>
					<strong>Ctrl + Z: </strong>
					{t("undo")}
				</li>
				<li>
					<strong>Ctrl + Shift + Z or Ctrl + Y: </strong>
					{t("redo")}
				</li>
				<li>
					<strong>Ctrl + F: </strong>
					{t("search")}
				</li>
				<li>
					<strong>Left Click Mouse Hold: </strong>
					{t("move")}
				</li>
				<li>
					<strong>Ctrl + Left Click Mouse Hold: </strong>
					{t("hold")}
				</li>
			</ul>
		</div>
	);
}
